<template>
  <v-layout>
    <Header />
    <transition
      enter-active-class="transition-opacity duration-300"
      leave-active-class="transition-opacity duration-300"
      enter-from-class="opacity-0"
      leave-to-class="opacity-0"
    >
    </transition>
    <section class="grid w-full h-[100vh] items-center pt-[66px] md:pt-[77px]">
      <NuxtPage /></section
  ></v-layout>
</template>

<script setup>
import Header from "~/components/revamp/Header.vue";
</script>
